import request from '@/utils/request'
import axios from 'axios'
import { BASE_URL } from '@/utils/config.js';
// import { getToken } from '@/utils/token'
// 登录
export async function login(data) {
  return request({
    url: '/login',
    method: 'post',
    data,
  })
}
//获取对话
export async function getChatList(data) {
  return request({
    url: `/get_chat_list?mode=${data.mode}${data.key_word?'&key_word='+data.key_word:''}`,
    method: 'post',
    data,
  })
}

//创建回话
export async function createChat(data) {
  return request({
    url: '/create_chat',
    method: 'post',
    data,
  })
}
//删除会话
export async function deleteChat(data) {
  return request({
    url: '/delete_chat',
    method: 'post',
    data,
  })
}
//修改标题
export async function updateChatTitle(data) {
  return request({
    url: '/update_chat_title',
    method: 'post',
    data,
  })
}
// 获取历史记录
export async function getMsgList(data) {
  return request({
    url: '/get_chat_detail?chat_id='+data.chat_id,
    method: 'post',
    data,
  })
}

// 发送消息
export async function sendMsg(data) {
  return request({
    url: '/send_msg',
    method: 'post',
    data,
  })
}
// 发送消息stream
export async function sendMsgStream(data) {
  return request({
    url: '/send_msg/stream',
    method: 'post',
    responseType: 'stream',
    data,
  })
}

// 播放视频
export async function generateVideoUrl(data) {
  return request({
    url: '/generate_video_url?video_id='+data.video_id ,
    method: 'post',
    data,
  })
}
// 下载视频
export async function playVideo(data) {
  return axios({
    url: BASE_URL+'/play_video?video_id='+data.video_id ,
    method: 'post',
    data,
    responseType: 'blob',
    headers: {
      // 'Content-Type': 'video/mp4 ',
        token: localStorage.getItem('token')
    },
  })
}

// 下载附件
export async function downloadFile(data) {
  return axios({
    url: BASE_URL+'/download_file?file_id='+data.file_id,
    method: 'post',
    data,
    responseType: 'blob',
    headers: {
      token: localStorage.getItem('token')
    },
  })
}


// 获取推荐的问题
export async function getRecommendQuestion(data) {
  return request({
    url: '/get_recommend_question',
    method: 'post',
    data,
  })
}
// 获取聊天的标题
export async function getChatTitle(data) {
  return request({
    url: '/get_chat_title?chat_id='+data.chat_id,
    method: 'post',
    data,
  })
}
// 反馈机器人回答的问题
export async function feedbackAnswer(data) {
  return request({
    url: '/feedback/answer' ,
    method: 'post',
    data,
  })
}
// 反馈机app的问题
export async function feedbackApp(data) {
  return request({
    url: '/feedback/app' ,
    method: 'post',
    data,
  })
}

 
//获取视频文件预览地址
export async function generatePlayUrl(data) {
  return request({
    url: '/generate_play_url?file_id='+data.file_id,
    method: 'post',
    data,
  })
}
//修改密码
export async function updatePassword(data) {
  return request({
    url: '/update_password',
    method: 'post',
    data,
  })
}